/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL211bHRpLWVkaXRvci9hY3Rpb24vYWN0aW9uLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL211bHRpLWVkaXRvci9hY3Rpb24vYWN0aW9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/action/action.component.scss.shim.ngstyle.ts